module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-2f391156.png";